import { useState, useEffect } from "react";

const MOBILE_QUERY = "(width < 80rem)";

/**
 * Returns true when the viewport is below the xl breakpoint (< 80 rem).
 * Uses MediaQueryList.addEventListener("change") so it only fires when the
 * breakpoint is actually crossed, not on every pixel of resizing.
 */
export default function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const handleChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return isMobile;
}
